module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main with-leads-table with-leads-table-active",
    attrs: {
      "slot": "main",
      "id": "dashboard-canvas"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [_c('h1', [_vm._v("Clients")]), _vm._v(" "), _c('div', {
    staticClass: "pivots-wrapper"
  }, [(_vm.pivot_branch_options.length) ? _c('span', {
    staticClass: "pivot label"
  }, [_vm._v("\n                Branch:\n                      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pivots.branch_code),
      expression: "pivots.branch_code"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pivots, "branch_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" - none - ")]), _vm._v(" "), _vm._l((_vm.pivot_branch_options), function(p) {
    return _c('option', {
      domProps: {
        "value": p[0]
      }
    }, [_vm._v(_vm._s(p[1]))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.pivot_type_options.length) ? _c('span', {
    staticClass: "pivot label"
  }, [_vm._v("\n                Policy Type:\n                      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pivots.policy_type_code),
      expression: "pivots.policy_type_code"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pivots, "policy_type_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" - none - ")]), _vm._v(" "), _vm._l((_vm.pivot_type_options), function(p) {
    return _c('option', {
      domProps: {
        "value": p[0]
      }
    }, [_vm._v(_vm._s(p[1]))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Clients by Branch")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'by_branch',
      "bc-data": _vm.stats.chart_by_branch.series,
      "bc-layout": _vm.stats.chart_by_branch.layout
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Clients by Type")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'by_type',
      "bc-data": _vm.stats.chart_by_type.series,
      "bc-layout": _vm.stats.chart_by_type.layout
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('epic-clients-table', {
    attrs: {
      "pivots": _vm.pivots,
      "datesRange": _vm.datesRange
    },
    on: {
      "loaded": _vm.refreshData
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47e4972b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/EpicClients.vue
// module id = 642
// module chunks = 0